import React, { useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomTextFieldSelectNormal = ({
  options = [],
  color,
  fontWeight,
  getOptionLabel = (option) => option?.label || option,
  getOptionValue = (option) => option?.value || option,
  error,
  helperText,
  backgroundColor,
  placeholder,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  return (
    <TextField
      select
      variant="outlined"
      size="small"
      placeholder
      SelectProps={{
        open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        displayEmpty: true, // ⬅️ required to allow empty display
        renderValue: (selected) => {
          if (!selected) {
            return <span style={{ color: "#9E9E9E" }}>{placeholder}</span>; // placeholder styling
          }
          const option = options.find(
            (opt) => getOptionValue(opt) === selected
          );
          return option ? getOptionLabel(option) : "";
        },
        IconComponent: () => (
          <ExpandMoreIcon
            style={{ cursor: "pointer", color: "#000000", marginRight: "10px" }}
            onClick={(e) => {
              e.stopPropagation(); // stop event from bubbling
              setOpen((prev) => !prev);
            }}
          />
        ),
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 200, // control dropdown height
              width: 300, // control dropdown width
            },
          },
        },
      }}
      sx={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : "#FFFFFF !important",
        borderRadius: "8px",
        "& .MuiOutlinedInput-root": {
          backgroundColor: backgroundColor ? backgroundColor : "#FFFFFF",
          borderRadius: "8px",
          borderColor: "#E0E0E0",
          "& fieldset": {
            borderColor: "#E0E0E0",
            transition: "border-color 0.3s ease",
          },
          "&:hover fieldset": {
            borderColor: "#E0E0E0",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#E0E0E0",
            borderWidth: "1px",
          },
        },
        "& .MuiSelect-select": {
          backgroundColor: backgroundColor ? backgroundColor : "#FFFFFF",
          padding: "10px 12px",
          fontSize: "14px",
          color: color ? color : "#000000",
          borderRadius: "4px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },
        "& .MuiInputBase-root": {
          height: 40, // ⬅️ decrease field height
          minHeight: 40,
        },
        "& .MuiSelect-select": {
          backgroundColor: backgroundColor ? backgroundColor : "#FFFFFF",
          padding: "6px 12px", // ⬅️ less padding = smaller height
          fontSize: "14px",
          color: color ? color : "#000000",
          borderRadius: "4px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },
        ...props.sx,
      }}
      error={error}
      helperText={helperText}
      {...props}
    >
      {options?.map((option, index) => (
        <MenuItem key={index} value={getOptionValue(option)}>
          {getOptionLabel(option)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CustomTextFieldSelectNormal;
